import { Pipe, PipeTransform } from '@angular/core';

/**
 * R$ no formato brasileiro sem registrar locale no Angular (o app não registra pt-BR).
 * Espaço não separável depois do R$: o valor nunca quebra em duas linhas.
 */
@Pipe({ name: 'brl', standalone: true })
export class BrlPipe implements PipeTransform {
  transform(valor: number | null | undefined): string {
    if (valor === null || valor === undefined || isNaN(Number(valor))) return '';
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/\s/, ' ');
  }
}
